var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { PollData_Poll_Settings_Permissions_VoteRole } from "./../../ricos-schema/legacy/wix/rich_content/v1";
const toPollServer = (poll) => {
  return __spreadProps(__spreadValues({}, toCreatePollPayload(poll)), {
    options: poll.options.map(toPollOption),
    id: poll.id,
    createdBy: poll.createdBy,
    count: poll.count,
    anonymousCount: poll.anonymousCount,
    creatorFlag: poll.creatorFlag,
    ownVotes: poll.ownVotes
  });
};
const toCreatePollPayload = (poll) => {
  var _a, _b, _c;
  return {
    title: poll.title,
    mediaId: poll.image.src.url,
    ownVotes: [],
    options: poll.options.map((option) => ({
      title: option.title,
      mediaId: option.image.src.url
    })),
    settings: {
      resultsVisibility: getResultsVisibility((_a = poll.settings.permissions) == null ? void 0 : _a.view),
      multipleVotes: !!((_b = poll.settings.permissions) == null ? void 0 : _b.allowMultipleVotes),
      voteRole: getVoteRole((_c = poll.settings.permissions) == null ? void 0 : _c.vote),
      votersDisplay: !!poll.settings.showVoters,
      votesDisplay: !!poll.settings.showVotesCount
    }
  };
};
const toPollOption = (option) => {
  return {
    id: option.id,
    title: option.title,
    mediaId: option.image.src.url,
    count: option.count,
    anonymousCount: option.anonymousCount,
    rating: option.rating,
    latestVoters: option.latestVoters
  };
};
const getResultsVisibility = (view) => view === "EVERYONE" ? "ALWAYS" : view === "VOTERS" ? "VOTERS_ONLY" : "ONLY_ME";
const getVoteRole = (vote) => vote === PollData_Poll_Settings_Permissions_VoteRole.UNRECOGNIZED || vote === void 0 ? "ALL" : vote;
export {
  toCreatePollPayload,
  toPollServer
};
//# sourceMappingURL=toPollServer.js.map
